// src/pages/Register.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api/api";
import Modal from "../components/Modal";

export default function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const [modalOpen, setModalOpen] = useState(false);

  // ✅ async function wrapper here
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      await api.post("/auth/register", {
        username: form.username,
        email: form.email,
        password: form.password,
        totp: form.totp || undefined,
      });

      setModalOpen(true);

    } catch (err) {
      console.error("Registration failed:", err);
      setError(err.response?.data?.detail || "Registration failed");
    }
  };

  return (
    <div className="auth-container" style={{ textAlign: "center" }}>
      <h2>Create Account</h2>
      {error && <p className="auth-error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={form.username}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={form.confirmPassword}
          onChange={handleChange}
          required
        />
        <button type="submit" className="nav-btn">
          Register
        </button>
      </form>
      <p>
        Already have an account? <Link to="/login">Login</Link>
      </p>

      <div style={{ marginTop: "2rem", textAlign: "center" }}>
        <img src="/logo.png" alt="CardStoard" style={{ width: "320px", maxWidth: "90%", height: "auto", opacity: 0.85 }} />
      </div>

      {/* ✅ Success Modal */}
      <Modal
        isOpen={modalOpen}
        title="Registration Successful 🎉"
        message="A verification email has been sent to your inbox. Please click the link in that email to activate your account. If you don't see it within a few minutes, check your spam or junk folder."
        onConfirm={() => navigate("/login")}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
}
